import React from 'react';
import './ProductFilter.css';

const ProductFilter = ({ categories = [], selectedCategory, setSelectedCategory, searchTerm, setSearchTerm }) => {
    return (
        <div className="product-filter-container">
            <select
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                className="category-filter"
            >
                <option value="">Filtrar por categoría</option>
                {categories.map((category) => (
                    <option key={category._id} value={category._id}>
                        {category.name}
                    </option>
                ))}
            </select>

            <input
                type="text"
                placeholder="Buscar por nombre"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="name-filter"
            />
        </div>
    );
};

export default ProductFilter;
